import { makeStyles } from 'tss-react/mui';

export const MOBILE_HEADER_HEIGHT = 60;

const name = 'MobileHeader';

export const useMobileHeaderStyles = makeStyles<number>({ name })(
  (theme, topBannersHeight) => ({
    root: {
      position: 'fixed',
      top: topBannersHeight,
      zIndex: 2,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      width: '100%',
      height: MOBILE_HEADER_HEIGHT,

      backgroundColor: theme.palette.background.paper,

      padding: theme.spacing(0, 7),

      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0, 9),
      },

      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(0, 4),
      },
    },
    buttons: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),

      [theme.breakpoints.down('xs')]: {
        gap: theme.spacing(1),
      },
    },
  }),
);
